import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { AjusteNominaView } from './components/ajusteNominaView';

const AjustesNominaPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: '/configuracion/ajuste',
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Ajustes nomina',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Ajustes nomina</PageTitle>
      <AjusteNominaView/>
    </>
  );
};

export {AjustesNominaPage}